<template>
  <div v-if="request" class="global-dialog-backdrop" @click="cancel" @keyup.escape="cancel">
    <div class="global-dialog" @click.stop="">
      <p>{{ request.message }}</p>

      <div v-if="request.type === 'prompt'" class="prompt-input">
        <input
          ref="inputRef"
          v-model="inputValue"
          @keyup.enter="submit"
          @keyup.escape="cancel"
        />
      </div>

      <div class="dialog-actions button-group">
        <button v-if="request.type === 'confirm'" @click="submit">OK</button>
        <button v-if="request.type === 'prompt'" @click="submit">OK</button>
        <button v-if="request.type === 'alert'" @click="submit">OK</button>
        <button v-if="request.type !== 'alert'" @click="cancel">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue';
import { useDialogStore } from '@/stores/useDialogStore';

const dialogStore = useDialogStore();
const request = computed(() => dialogStore.currentRequest);

const inputValue = ref('');
const inputRef = ref<HTMLInputElement | null>(null);

watch(request, async (newReq) => {
  if (newReq?.type === 'prompt') {
    inputValue.value = newReq.defaultValue || '';
    await nextTick();
    inputRef.value?.focus();
    inputRef.value?.select();
  }
});

const submit = () => {
  if (request.value?.type === 'confirm') {
    dialogStore.closeDialog(true);
  } else if (request.value?.type === 'prompt') {
    dialogStore.closeDialog(inputValue.value);
  } else if (request.value?.type === 'alert') {
    dialogStore.closeDialog(undefined);
  }
};

const cancel = () => {
  if (request.value?.type === 'confirm') {
    dialogStore.closeDialog(false);
  } else if (request.value?.type === 'prompt') {
    dialogStore.closeDialog(null);
  } else if (request.value?.type === 'alert') {
    dialogStore.closeDialog(undefined);
  }
};
</script>

<style scoped lang="scss">
.global-dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.global-dialog {
  background: var(--background-color, #222);
  color: white;
  padding: 20px;
  border-radius: 15px;
  border: 3px solid var(--border-color, #111);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  min-width: 300px;
  max-width: 90vw;
  text-align: center;
}
.prompt-input {
  margin: 15px 0;
  input {
    width: 100%;
    padding: 8px;
    font-size: 16px;
    box-sizing: border-box;
    border-radius: 5px;
    background: #444;
    color: white;
    border: 1px solid #666;
  }
}
.dialog-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;

  button {
    min-width: 80px;
  }
}
</style>
